let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j3RF1")).then(() => parcelRequire('kxLed'));